import React from 'react'
import PropTypes from 'prop-types'
import videoSrc from './matterhorn.mp4'
import { ReactSpecimen } from 'catalog';

const stageMarkup = props => {
  const mediaElement = (media) => {
    if (media === 'video') {
      return (
        <video muted autoPlay loop>
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      )
    } else {
      return (
        <img
          src="https://zurich.com/-/media/Project/Zurich/Dotcom/careers/images/stage-search-apply.jpg"
          alt=""
          data-variantitemid="{879B873C-EEF5-4CC9-8205-604CBB2B8DDE}"
          data-variantfieldname="PromoIcon"
        />
      )
    }
  }

  return (
    <ReactSpecimen responsive={['desktop', 'tablet portrait', 'mobile portrait']} noSource={true}>
      <div className={`component stage-main mod-stage mod-stage--${props.position} mod-stage--crop-${props.crop} ${props.theme ? 'mod-stage--light' : ''} ${props.scroller.length > 1 ? 'mod-stage--' + props.scroller : ''} ${props.noBackground ? 'mod-stage--no-bg' : ''} col-12`}>
        <div className="component-content">
          <div className="mod-stage-image field-promoicon">{mediaElement(props.media)}</div>
          <div className="mod-stage-content">
            <div>
              <div className="field-promotext">
                <h1>
                  {!props.multiline ? 'Headline' : 'Lorem ipsum dolor sit amet, consetetur sadipscing'}
                </h1>
                <p>
                  To see the grid columns, on the ribbon, on the View tab, select Grid. ... In the Grid section, on the
                  Basic tab, change the width of the rendering.
                </p>
              </div>
              <div className="field-promolink">
                {!props.theme &&
                <a data-variantitemid="{879B873C-EEF5-4CC9-8205-604CBB2B8DDE}"
                   className="btn btn--primary" href="http://google.com"
                   data-variantfieldname="PromoLink">
                  Read more
                </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactSpecimen>
  )
}

stageMarkup.propTypes = {
  crop: PropTypes.string,
  media: PropTypes.string,
  scroller: PropTypes.string,
  multiline: PropTypes.bool,
  position: PropTypes.string
}

export default stageMarkup;



// WEBPACK FOOTER //
// ./catalog/stage/stage-markup.js